module.exports = __webpack_public_path__ + "img/nextIcon.98348500.svg";